import type { Point } from './types';

export const clamp = (value: number, min: number, max: number): number => Math.max(min, Math.min(max, value));

export const distance = (a: Point, b: Point): number => Math.hypot(a.x - b.x, a.y - b.y);

export const distanceSquared = (a: Point, b: Point): number => {
	const dx = a.x - b.x;
	const dy = a.y - b.y;
	return dx * dx + dy * dy;
};

export const normalize = (point: Point): Point => {
	const length = Math.hypot(point.x, point.y) || 1;
	return { x: point.x / length, y: point.y / length };
};

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const lerpPoint = (a: Point, b: Point, t: number): Point => ({
	x: lerp(a.x, b.x, t),
	y: lerp(a.y, b.y, t),
});

export const angleBetween = (a: Point, b: Point): number => Math.atan2(b.y - a.y, b.x - a.x);

export const rotate = (point: Point, angle: number): Point => ({
	x: point.x * Math.cos(angle) - point.y * Math.sin(angle),
	y: point.x * Math.sin(angle) + point.y * Math.cos(angle),
});

export const seededNoise = (seed: number): number => {
	const value = Math.sin(seed * 12.9898) * 43758.5453;
	return value - Math.floor(value);
};
